import './utils/telemetry';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import './index.css';
import 'carbon-react/esm/style/fonts.css';
import './assets/sage-fonts.css';
import I18nProvider from 'carbon-react/esm/components/i18n-provider';
import frFR from 'carbon-react/esm/locales/fr-fr';

// Legacy AngularJS hash-based URL migration:
// Redirect URLs like /#/?key=value&key2=value2 to /?key=value&key2=value2
const hash = window.location.hash;
if (hash.startsWith('#/')) {
  const newUrl = hash.substring(1); // Remove the '#', keep '/...'
  window.history.replaceState(null, '', newUrl);
}

// Capture session_transfer_token and stateConnect before React Router processes the URL
const initialParams = new URLSearchParams(window.location.search);
const sessionTransferToken = initialParams.get('session_transfer_token');
if (sessionTransferToken) {
  sessionStorage.setItem('session_transfer_token', sessionTransferToken);
  initialParams.delete('session_transfer_token');

  const stateConnect = initialParams.get('stateConnect');
  if (stateConnect) {
    sessionStorage.setItem('session_transfer_state_connect', stateConnect);
    initialParams.delete('stateConnect');
  }

  const cleanSearch = initialParams.toString();
  const cleanUrl = `${window.location.pathname}${cleanSearch ? `?${cleanSearch}` : ''}`;
  window.history.replaceState(null, '', cleanUrl);
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Propager les erreurs vers les ErrorBoundaries
      throwOnError: true,

      // Configuration retry globale
      retry: (
        failureCount: number,
        err: Error & { status?: number; response?: { status?: number } },
      ) => {
        if (
          (err?.status && err.status >= 400 && err.status < 500) ||
          (err?.response?.status && err.response.status >= 400 && err.response.status < 500)
        ) {
          return false;
        }

        return failureCount < 3;
      },
      staleTime: Infinity,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <I18nProvider locale={frFR}>
        <React.Suspense fallback={<div>Loading...</div>}>
          <App />
        </React.Suspense>
      </I18nProvider>
    </BrowserRouter>
  </QueryClientProvider>,
);
